import { render, staticRenderFns } from "./ElementNone.vue?vue&type=template&id=234827ed&"
import script from "./ElementNone.vue?vue&type=script&lang=ts&"
export * from "./ElementNone.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports